const name = 'ActionForm'
export default {
  name,
  data () {
    return {
        objForm: []
    }
  },

  methods: {
    GetResultForm (response) {
        let result = response.data.data
        if (result != null ) {
            Object.keys(result).forEach((Element) => {
                this.objForm[Element] = result[Element]
            })
        }
    }
   },
  computed: { 
   
  }, 

};